export default "__VITE_ASSET__Ctk7dk4F__"